import React, { useState } from "react";
import ReactDOM from "react-dom";
import { FaCopy } from "react-icons/fa";
import "./WebCodeModals.css";

/**
 * Reusable modals for web_code (delivery) coupons
 * Shows discount code and handles opening the target website
 */
const WebCodeModals = ({
  coupon,
  isOpen,
  onClose,
  showToast
}) => {
  const [copySuccess, setCopySuccess] = useState(false);

  // Copy discount code to clipboard
  const copyDiscountCode = async (code) => {
    try {
      await navigator.clipboard.writeText(code);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error('Failed to copy code:', err);
    }
  };

  // Handle copy and open website
  const handleCopyAndOpenWebsite = async () => {
    if (!coupon) return;

    try {
      // Copy the discount code
      if (coupon.discount_code) {
        await navigator.clipboard.writeText(coupon.discount_code);
      }

      // Open the target URL in a new window
      if (coupon.target_url) {
        window.open(coupon.target_url, '_blank', 'noopener,noreferrer');
      }

      if (showToast) {
        showToast("Code copied! Opening website...", "success");
      }

      // Close the modal
      onClose();
      setCopySuccess(false);
    } catch (err) {
      console.error('Failed to copy and open website:', err);
      if (showToast) {
        showToast("Failed to copy code. Please try again.", "error");
      }
    }
  };

  if (!isOpen || !coupon) return null;

  return ReactDOM.createPortal(
    <div className="modal-backdrop webcode-discount-modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <h3 className="modal-title">
          Your Discount Code
        </h3>

        {coupon.discount_code && (
          <>
            <div className="webcodemodal-code-container">
              <span className="webcodemodal-code-text">
                {coupon.discount_code}
              </span>
              <FaCopy
                onClick={() => copyDiscountCode(coupon.discount_code)}
                className={`webcodemodal-copy-icon ${copySuccess ? 'copied' : ''}`}
                title={copySuccess ? 'Copied!' : 'Copy to clipboard'}
              />
            </div>

            <p className="modal-confirm-text">
              After clicking Visit Site, you will be redirected to the ordering website and the code will be automatically copied to your clipboard.
            </p>
          </>
        )}

        <div className="webcodemodal-button-container">
          <button
            onClick={handleCopyAndOpenWebsite}
            className="modal-btn-confirm webcodemodal-visit-button"
          >
            Visit Site
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default WebCodeModals;
